import React from "react";
import DWPlayerList from "../components/DWPlayerList";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
const DW20Joining = ({ users }) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="dw-joining"
    >
      <motion.div variants={staticBounceVariants} className="game-name">
        <h2 className="name">Done with 2020</h2>
      </motion.div>
      <motion.h3 variants={fadeVariants} className="waiting-txt">
        Waiting to Start...
      </motion.h3>
      <DWPlayerList users={users} />
    </motion.div>
  );
};

export default DW20Joining;
